<template>
  <div class="page-about">About</div>
</template>
